import { Button } from "components/atoms/button/button";
import styled from "styled-components";

export const CMBAckWrapper = styled.div`
  text-align: center;
`;

export const CMBAckHeading = styled.h2`
  font-weight: 700;
  margin: 0;
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  line-height: 36px;
`;

export const CMBPhoneNumberInfo = styled.p`
  font-size: ${({ theme }) => theme.fontSizes["xl"]};
  font-family: ${({ theme }) => theme.fonts.secondary};
  margin: 0;
  line-height: 30px;
`;

export const CMBPhoneNumber = styled.span`
  font-weight: bold;
`;

export const CMBOnDiffNumberButton = styled(Button)`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: 20px;
  font-weight: 700;
  margin: 0 auto;
`;

export const OkayButton = styled(Button)`
  font-size: ${({ theme }) => theme.fontSizes.md};
  margin: auto;
  width: 320px;
`;

export const OfficeHoursInfoWrapper = styled.div`
  background: ${({ theme }) => theme.colors.yellow["100"]};
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  border-radius: 6px;
`;

export const OfficeHoursInfo = styled.div`
  font-family: ${({ theme }) => theme.fonts.secondary};
  color: ${({ theme }) => theme.colors.neutral["1000"]};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  padding: 12px;
  width: fit-content;
`;
